"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.utilities = void 0;

var border = _interopRequireWildcard(require("./border"));

var form = _interopRequireWildcard(require("./form"));

var palette = _interopRequireWildcard(require("./palette"));

var radius = _interopRequireWildcard(require("./radius"));

var surface = _interopRequireWildcard(require("./surface"));

var typography = _interopRequireWildcard(require("./typography"));

var reset = _interopRequireWildcard(require("./reset"));

var animation = _interopRequireWildcard(require("./animation"));

var utilities = {
  border: border,
  form: form,
  palette: palette,
  radius: radius,
  surface: surface,
  typography: typography,
  reset: reset,
  animation: animation
};
exports.utilities = utilities;